// 高亮敏感词
export const highlightWords = (text, words) => {
  if (!words || words.length === 0) return text;

  const escapeRegExp = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  // 检测是否为英文单词（包含英文字母）
  const isEnglishWord = (word) => /[a-zA-Z]/.test(word);

  let result = text;
  words.forEach((word) => {
    const escapedWord = escapeRegExp(word);
    let regex;

    if (isEnglishWord(word)) {
      // 英文敏感词：使用单词边界，确保左右两边都是空格或边界
      regex = new RegExp(`\\b${escapedWord}\\b`, 'gi');
    } else {
      // 非英文敏感词：使用原来的匹配方式
      regex = new RegExp(escapedWord, 'gi');
    }

    result = result.replace(regex, (matched) => `<span style="color: red;font-weight: bold;">${matched}</span>`);
  });
  return result;
};
